import { isBrowser, isMobile } from 'react-device-detect';
import { FlexStack, Icon, Select } from '~/components/atomic';
import { InputLabelTitle } from '~/components/common';
import { Gender, genders } from '~/types';
import { useSignUpStepStore } from '~/store';
import * as S from './Profile.styled';

export default function ProfileGender() {
  const { gender, setGender } = useSignUpStepStore((state) => ({
    gender: state.profile.gender,
    setGender: state.setGender,
  }));
  const handleGenderChange = (option: string) => setGender(option as Gender);
  const handleGenderSelectChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    setGender(event.target.value as Gender);
  };

  return (
    <S.Container>
      <FlexStack spacing={4}>
        <InputLabelTitle title='Gender' />
        {isBrowser && (
          <Select
            modalTitle={'Gender'}
            selectedOption={gender}
            isPlaceholder={'Select your gender'}
            selectOptions={genders}
            click={(option: string) => handleGenderChange(option)}
          >
            {!gender ? 'Select your gender' : gender}
          </Select>
        )}
        {isMobile && (
          <S.MobileSelectBox>
            <S.MobileSelect
              name='profile_gender'
              id='profileGender'
              onChange={handleGenderSelectChange}
              value={gender || ''}
              placeholder='Select your gender'
              className={!gender ? 'placeholder' : ''}
            >
              <option value='' disabled className='placeholder'>
                Select your gender
              </option>
              {genders.map((gender, idx) => (
                <option key={`${gender}_${idx}`} value={gender}>
                  {gender}
                </option>
              ))}
            </S.MobileSelect>
            <S.StyledIcon>
              <Icon iconName='ArrowDown' size={20} color='caption1' />
            </S.StyledIcon>
          </S.MobileSelectBox>
        )}
      </FlexStack>
    </S.Container>
  );
}
